import React, { useState } from 'react';
import { Popover } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { base64Kit } from '@/utils/base64-kit';
import { BaseLayerViewType, PluginEnum } from '@/version-types';
import './image-layer-ai-item.less';
import { ContextMenuEvents } from '../../../type';

enum Menu {
    'AIExpendImage',
    'AIModifyImage',
    'AIGenerateImage',
    'AITextMaterial',
}

export enum Env {
    Release = 'Release',
    Test = 'Test',
}

interface IConfig {
    hiddenAIGenerateImage?: boolean;
}

const defaultConfig: IConfig = {
    hiddenAIGenerateImage: false,
};

export const setConfig = (config: Partial<IConfig>) => {
    Object.assign(defaultConfig, config);
};

const MenuList = (showAIGenerateImage = false) => {
    const { $t } = getLocaleStore();
    const ls = [
        {
            label: $t((v) => v.baseLayer.imageLayerAiItem.aIExpendImage),
            value: Menu.AIExpendImage,
        },

        {
            label: $t((v) => v.baseLayer.imageLayerAiItem.aIModifyImage),
            value: Menu.AIModifyImage,
        },

        {
            label: $t((v) => v.baseLayer.imageLayerAiItem.aiTextMaterial),
            value: Menu.AITextMaterial,
        },
    ];
    if (showAIGenerateImage) {
        ls.unshift({
            label: 'AI生图',
            value: Menu.AIGenerateImage,
        });
    }
    return ls;
};

const ImageLayerAiItem: React.FC<{
    hasAiText?: boolean;
}> = ({ hasAiText = false }) => {
    const framework = useFramework();
    // 团队版 + pc内嵌的web
    const hasAIGenerateImage = !window.isIntl && !defaultConfig.hiddenAIGenerateImage;
    const [renderKey, setRenderKey] = useState(0);

    const menuItemClick = (value: Menu) => {
        if (value === Menu.AIExpendImage) {
            framework.events.emit(ContextMenuEvents.openPlugin, { func: PluginEnum.AI_EXPEND_IMAGE });
            framework.events.emitShortcutEvent(PluginEnum.AI_EXPEND_IMAGE);
        } else if (value === Menu.AIModifyImage) {
            framework.events.emit(ContextMenuEvents.openPlugin, { func: PluginEnum.AI_MODIFY_IMAGE });
            framework.events.emitShortcutEvent(PluginEnum.AI_MODIFY_IMAGE);
        } else if (value === Menu.AIGenerateImage) {
            const activeLayer = framework.operate.getActivePickLayer();
            framework.events.emit(ContextMenuEvents.aiGenerateImageEnter, 'quick');
            const url = base64Kit.getLocalUrl((activeLayer?.data as any)?.url ?? '');
            framework.events.emit(ContextMenuEvents.openPlugin, {
                func: PluginEnum.AI_GENERATE_IMAGE,
                extData: {
                    replaceActiveImageLayer: true,
                    url,
                },
            });
            framework.events.emitShortcutEvent(PluginEnum.AI_GENERATE_IMAGE);
        } else if (value === Menu.AITextMaterial) {
            framework.events.emit(ContextMenuEvents.openPlugin, { func: PluginEnum.AI_TEXT });
            framework.events.emitShortcutEvent(PluginEnum.AI_TEXT);
        }
        setRenderKey(renderKey + 1);
    };

    return (
        <div className="shortcut-list__item c-imageLayerAiItem" data-type={BaseLayerViewType.SHORTCUT}>
            <Popover
                placement="bottomLeft"
                overlayClassName="l-content-menu-popover"
                key={renderKey}
                content={
                    <div className="c-imageLayerAiItem-menu">
                        {MenuList(hasAIGenerateImage)
                            .filter((item) => !(!hasAiText && item.value === Menu.AITextMaterial))
                            .map((item) => {
                                return (
                                    <div
                                        key={item.value}
                                        className="item"
                                        data-type={BaseLayerViewType.SHORTCUT}
                                        onClick={() => menuItemClick(item.value)}
                                    >
                                        {item.label}
                                    </div>
                                );
                            })}
                    </div>
                }
            >
                <div className="icon">
                    <IconFont name="AiTools" fontSize={16} color="var(--content-list-primary)" />
                </div>
            </Popover>
        </div>
    );
};

export default ImageLayerAiItem;
